import { render, staticRenderFns } from "./return-user-assignment.vue?vue&type=template&id=861bce5c"
import script from "./return-user-assignment.vue?vue&type=script&lang=ts"
export * from "./return-user-assignment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports